import React from "react";
import { ColorsData } from "../../../data/colors.data";
import IsPortrait from '../../helpers/WindowOrientation';

interface Props {
  car: any;
  color: any;
  reset: boolean;
  setColor: (value: any) => void;
  setReset: (value: boolean) => void;
}

const BottombarColor: React.FC<Props> = ({ car, color, reset, setColor, setReset}) => {
  
  const [colorList, setColorList] = React.useState<any>([]);
  const isPortrait: boolean = IsPortrait();

  React.useEffect(() => {
    if(car){
      const colorData: any = ColorsData();
      const colors = colorData[car.id] ;
      if(colors){
        const color_list: any = [];
        for (const color of colors) {
          if (color.active)
            color_list.push(color);
        }
        setColorList(color_list);
        if(reset === true){
          setColor(color_list[0]);
          setReset(false);
        }
      }
    }
  }, [car, reset, setColor, setReset]);
  
  return (
    <div className="bottombar-menu-color">
      <div className={`bottombar-color-selection ${isPortrait ? 'portrait' : ''}`}>
        {
          (colorList as {}[]).map((colorItem: any, index: number) =>
            // <img key={index} className={`bottombar-color-element ${colorItem.id === color.id ? 'selected' : ''}`} src={colorItem.icon} onClick={() => {if(colorItem.interactable === true){setColor(colorItem)} }} alt='' />
            <div key={index} className={`bottombar-color-element ${colorItem.id === color.id ? 'selected' : ''}`} onClick={() => {if(colorItem.interactable === true){setColor(colorItem)} }}>
              <img className={`bottombar-color-img`} src={colorItem.icon} alt='' />
            </div>
          )
        }
      </div>
      {color && <div className='bottombar-color-text'>{color.name}</div>}
    </div>
  );
};

export default BottombarColor;